var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "podcast-settings-popup",
      class: { "dark-theme": _vm.isDarkMode },
    },
    [
      !_vm.showLoading
        ? _c("div", { staticClass: "podcast-loading" }, [
            _c("div", { staticClass: "loading-section" }, [
              _c("div", { staticClass: "spinner" }),
              _vm._v(" "),
              _c("p", { staticClass: "loading-text" }, [
                _vm._v(
                  _vm._s(_vm.$t("briefing.recap.podcastLoading.textCreating"))
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "sub-text" }, [
                _vm._v(
                  _vm._s(_vm.$t("briefing.recap.podcastLoading.textNote"))
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "sub-text" }, [
                _vm._v(_vm._s(_vm.$t("briefing.recap.podcastLoading.text"))),
              ]),
            ]),
          ])
        : _c("div", { staticClass: "go-panel" }, [
            _c("div", { staticClass: "go-panel-header" }, [
              _c("div", { staticClass: "go-panel-title" }, [
                _c("i", { staticClass: "go-icon-24 go-icon-headphones" }),
                _vm._v(" "),
                _c("em", { staticClass: "go-text" }, [
                  _vm._v(
                    _vm._s(_vm.$t("briefing.recap.podcastLoading.listen"))
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "go-panel-btn" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn go-btn-icon go-btn-close",
                    attrs: { type: "button" },
                  },
                  [
                    _c("i", {
                      staticClass: "go-icon-20 go-icon-share",
                      on: { click: _vm.copyPodcastUrl },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn go-btn-icon go-btn-close",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.downloadPodcast.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm.downloadStatus
                      ? _c("b-spinner", {
                          staticClass: "b-spinner",
                          staticStyle: {
                            opacity: "0.6",
                            "border-width": "1px",
                          },
                          attrs: { small: "" },
                        })
                      : _c("i", { staticClass: "go-icon-20 go-icon-download" }),
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.isHideSetting
                  ? _c(
                      "button",
                      {
                        staticClass: "btn go-btn-icon go-btn-close",
                        attrs: { type: "button" },
                      },
                      [
                        _c("i", {
                          staticClass: "go-icon-20 go-icon-setting",
                          on: { click: _vm.goBackSetting },
                        }),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "go-panel-body" }, [
              _c("div", { staticClass: "pod-cast-wrap listening" }, [
                _c("div", { staticClass: "go-block-wrap" }, [
                  _c("div", { staticClass: "go-user-thumb" }, [
                    _c("img", { attrs: { src: _vm.dataPodcast.image } }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-text-wrap" }, [
                    _c("span", { staticClass: "go-text-date" }, [
                      _vm._v(" " + _vm._s(_vm.dataPodcast.publishedAt) + " "),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "go-text-title" }, [
                      _vm._v(_vm._s(_vm.dataPodcast.title)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "go-text-name" }, [
                      _vm._v(
                        _vm._s(_vm.dataPodcast.hostName) +
                          ", " +
                          _vm._s(_vm.dataPodcast.guestName)
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pod-cast-player" }, [
                  _c("div", { staticClass: "pod-cast-player-range" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.playerProgress,
                          expression: "playerProgress",
                        },
                      ],
                      staticClass: "go-form-range",
                      attrs: {
                        type: "range",
                        id: "customRange",
                        disabled: !_vm.podcastEnabled,
                        max: "100",
                      },
                      domProps: { value: _vm.playerProgress },
                      on: {
                        input: _vm.onProgressChange,
                        __r: function ($event) {
                          _vm.playerProgress = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.formatTime(_vm.currentTime))),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.formatTime(_vm.totalTime))),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "pod-cast-player-btn",
                      staticStyle: { display: "flex" },
                    },
                    [
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-icon",
                            class: { active: _vm.isPlaying },
                            attrs: {
                              type: "button",
                              disabled: !_vm.podcastEnabled,
                            },
                            on: { click: _vm.togglePlay },
                          },
                          [
                            _c("i", {
                              staticClass: "go-icon-24",
                              class: _vm.isPlaying
                                ? "go-icon-player-pause-filled"
                                : "go-icon-player-play-filled",
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-icon active",
                            attrs: { type: "button" },
                            on: { click: _vm.resetAudio },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "go-icon-24 go-icon-player-stop-filled",
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-icon",
                            attrs: { type: "button" },
                            on: { click: _vm.toggleMute },
                          },
                          [
                            _c("i", {
                              staticClass: "go-icon-24",
                              class: _vm.isMuted
                                ? "go-icon-volume-off"
                                : "go-icon-volume",
                            }),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }